import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'kis-username-icon',
  templateUrl: './username-icon.component.html',
  styleUrls: ['./username-icon.component.scss']
})
export class UsernameIconComponent implements OnInit {

  /** User full name */
  @Input()
  name = '';

  /** Returns initials from name */
  get initials(): string {
    return this.name
      .split(' ')
      .map((str) => str.length ? str[0] : '')
      .filter((char) => /[a-z]/i.test(char))
      .join('')
      .toUpperCase();
  }

  constructor() { }

  ngOnInit() {
  }

}
